import { render, staticRenderFns } from "./SmallBlog.vue?vue&type=template&id=383560c7&"
import script from "./SmallBlog.vue?vue&type=script&lang=js&"
export * from "./SmallBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports